<template lang="">
  <div id="wrap">
    <!--  레퍼런스 -->
    <!--  레퍼런스 # DB손해보험 SH -->
    <!--  레퍼런스 #  -->
    <v-sheet elevation="0" class="mx-auto landing-warpper" rounded>
      <div v-for="(group, index) in groupList" :key="index">
        <v-sheet max-width="1600" class="mx-auto pa-5" elevation="0">
          <v-container>
            <v-row align="start">
              <v-col v-for="(item, idx) in group" :key="idx" cols="12" md="6">
                <ReferCard class="mt-2" :title="item" />
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </div>
    </v-sheet>
    <!--  레퍼런스 -->
  </div>
</template>
<script>
import ReferCard from './seesJobmindReferCard.vue';
import referData from '@/assets/oncrew_refer.json';
export default {
  data: () => ({
    //
    list: referData.sort((t1, t2) => (t1.id < t2.id ? -1 : 1)),
  }),
  components: {
    ReferCard,
  },
  computed: {
    groupList() {
      const result = [];
      for (let i = 0; i < this.list.length; i += 2) {
        //result.push([this.list[i], this.list[i + 1]]);
        result.push(this.list.slice(i, i + 2));
      }
      return result;
    },
  },
};
</script>
<style>
@import '@/assets/css/seesJobmind';
</style>
